"use client";

import cls from "./BlogPromoCard.module.css";
import { MeetOurExpertsCorner } from "@/utils/images/MeetOurExperts";
import { CheckCircleIcon } from "@/utils/images/Blog";
import { Button } from "@/components/UI/Button/Button";
import { CALENDAR_URL } from "@/utils/consts";

const DEFAULT_ITEMS = [
    "Dedicated development teams",
    "Business automation",
    "Data collection & pipelines",
    "Web & mobile development",
];

interface BlogPromoCardProps {
    title?: string;
    subtitle?: string;
    items?: string[];
    buttonText?: string;
    href?: string;
    className?: string;
}

export const BlogPromoCard = ({
    title = "UData",
    subtitle = "Software outstaffing & automation",
    items = DEFAULT_ITEMS,
    buttonText = "Contact us",
    href = CALENDAR_URL,
    className = "",
}: BlogPromoCardProps) => {
    return (
        <div className={`${cls.promoCard} ${className}`}>
            <div className={cls.corner}><MeetOurExpertsCorner /></div>

            <div className={cls.content}>
                <div className={cls.heading}>
                    <p className={cls.title}>{title}</p>
                    <p className={cls.subtitle}>{subtitle}</p>
                </div>

                <ul className={cls.list}>
                    {items.map((item, index) => (
                        <li key={index} className={cls.listItem}>
                            <span className={cls.listIcon}><CheckCircleIcon style={{width: "22px", height: "22px"}} /></span>
                            <span>{item}</span>
                        </li>
                    ))}
                </ul>

                <Button className={cls.button} href={href} target={href !== CALENDAR_URL} invert>
                    {buttonText}
                </Button>
            </div>
        </div>
    );
};
